import { Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Editor, Toolbar, toHTML } from 'ngx-editor';

@Component({
  selector: 'app-wysiwyg-input',
  templateUrl: './wysiwyg-input.component.html',
  styleUrls: ['./wysiwyg-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WysiwygInputComponent),
      multi: true
    }
  ]
})
export class WysiwygInputComponent implements ControlValueAccessor, OnDestroy {
  @Input() formControl: FormControl;

  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic', 'underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link'],
    ['text_color', 'background_color'],
    ['horizontal_rule', 'format_clear'],
  ];

  value: string;
  isDisabled: boolean;

  /**
   *
   */
  constructor() {
    this.editor = new Editor();
  }

  private onChange = (value: any) => { };
  private onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  modelChanged(value: string): void {
    this.updateValue(value);
  }

  updateValue(newValue: string | Record<string, any>): void {
    // Convert to HTML if object
    if (typeof newValue === 'object') {
      newValue = toHTML(newValue);
    }
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();
  }

  ngOnDestroy() {
    // Clean up the editor
    this.editor.destroy();
  }
}
